"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return DebounceCallback;
    }
});
class DebounceCallback {
    call() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(()=>{
            this.callback();
        }, this.delay);
    }
    constructor(callback, delay){
        this.callback = callback;
        this.delay = delay;
        this.timer = null;
    }
}
